import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const Dashboard = () => import('./views/Index.vue');

export default [
  {
    path: '/dashboard',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin' },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: i18n.global.t('main.dashboard') },
      },
    ],
  },
];
